import { prop } from 'ramda';

export class Block {
  constructor(title, tasks) {
    this.title = title;
    this.tasks = tasks || [];
  }

  get tasksDone() {
    return this.tasks.filter(prop('isDone')).length;
  }

  get tasksTotal() {
    return this.tasks.length;
  }
}

const normalizeNumber = (number) => number.toString().padStart(2, 0);
export const formatDate = (date) => `${normalizeNumber(date.getDate())}.${normalizeNumber(date.getMonth() + 1)}.${date.getFullYear()}`;

const invertDate = date =>  date.split('.').reverse().join('');
export const isFirstDateEarlier = (firstDate, secondDate) => invertDate(firstDate) < invertDate(secondDate);
